import axios from 'axios';
const instance = axios.create({ baseURL: '', withCredentials: true });

instance.interceptors.request.use(config => { config.headers = { ...config.headers, 'Content-Type': config.headers['Content-Type'] || 'application/json', 'X-Requested-With': 'XMLHttpRequest' }; return config; });

instance.interceptors.response.use( response => response, error => { if (error.response && (error.response.status === 401 || error.response.status === 403)) { console.error('Authentication error:', error.response.data); } return Promise.reject(error); } );

export default instance;